import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  vacantLandParcels: "VacantLandParcel.VacantLandParcels",
  list: "VacantLandParcel.VacantLandParcelList",
  new: "VacantLandParcel.VacantLandParcelNew",
  base: "VacantLandParcel.VacantLandParcelBase",
  view: "VacantLandParcel.VacantLandParcelView",
  edit: "VacantLandParcel.VacantLandParcelEdit",
  complaints: "VacantLandParcel.VacantLandParcelComplaints",
  complaintInvestigationsChildList: "VacantLandParcel.ComplaintInvestigationsChildList",
  vacantLandInspectionsChildList: "VacantLandParcel.VacantLandInspectionsChildList",
  enforcementActions: "VacantLandParcel.VacantLandParcelEnforcementActions",
  notes: "VacantLandParcel.VacantLandParcelNotes",
  noteEdit: "VacantLandParcel.VacantLandParcelNoteEdit",
  noteNew: "VacantLandParcel.VacantLandParcelNoteNew",
  audit: "VacantLandParcel.VacantLandParcelAudit",
};

export { names as vacantLandParcelRouteNames };

const vacantLandParcelRoutes: RouterOptions["routes"] = [
  {
    path: "/vacantLandParcel",
    name: names.vacantLandParcels,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Vacant Land Parcels" },
        component: () => import("@/views/vacantLandParcel/VacantLandParcelList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/vacantLandParcel/VacantLandParcelBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Vacant Land Parcel", isNew: true },
            component: () => import("@/views/vacantLandParcel/VacantLandParcelEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/vacantLandParcel/VacantLandParcelBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Vacant Land Parcel View" },
            component: () => import("@/views/vacantLandParcel/VacantLandParcelView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Vacant Land Parcel Edit", isForm: true },
            component: () => import("@/views/vacantLandParcel/VacantLandParcelEdit.vue"),
          },
          {
            path: "complaints",
            name: names.complaints,
            meta: { title: "Vacant Land Parcel Complaints" },
            component: () => import("@/views/vacantLandParcel/ComplaintChildList.vue"),
          },
          {
            path: "investigations",
            name: names.complaintInvestigationsChildList,
            meta: { title: "Investigations" },
            component: () => import("@/views/vacantLandParcel/InvestigationChildList.vue"),
          },
          {
            path: "inspections",
            name: names.vacantLandInspectionsChildList,
            meta: { title: "Inspections" },
            component: () => import("@/views/vacantLandParcel/VacantLandInspectionChildList.vue"),
          },
          {
            path: "enforcementActions",
            name: names.enforcementActions,
            meta: { title: "Vacant Land Enforcement Actions" },
            component: () => import("@/views/vacantLandParcel/EnforcementActionChildList.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Vacant Land Parcel Notes" },
            component: {
              render: () => (
                <EntityNotes idField="vacantLandParcelId" routeNamePrefix="VacantLandParcel.VacantLandParcelNote" />
              ),
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Vacant Land Parcel Note", isForm: true },
            component: () => import("@/views/vacantLandParcel/VacantLandParcelNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Vacant Land Parcel Note", isForm: true },
            component: () => import("@/views/vacantLandParcel/VacantLandParcelNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Vacant Land Parcel Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="VacantLandParcel" />,
            },
          },
        ],
      },
    ],
  },
];
export default vacantLandParcelRoutes;
